import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * Meridian's type scale (styles.css): without it tailwind-merge reads `text-body` as a color, and a later `text-ink`
 * would drop the size.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: [
        "hero",
        "display",
        "headline",
        "title",
        "heading",
        "subheading",
        "body",
        "body-public",
        "small",
        "label",
        "caption",
        "tag",
      ],
    },
  },
});

/** Merges class names, letting later Tailwind utilities override earlier ones. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
